// const baseUrl = "http://localhost:8080"; //dev
const baseUrl = "https://jarvis.work:8080"; //prod
export const constant = Object.freeze({
  // Public origin of the live site. Canonical URLs are built from this — NOT
  // from window.location — so they always point to the production host and
  // never leak the dev origin or query strings (utm, fbclid) into <link
  // rel="canonical">. Independent of the API baseUrl above.
  CONST_SITE_URL: `https://sarcasm.co`,
  // Other Constants
  CONST_HAMBURGER_ICON: `https://icons.veryicon.com/png/o/miscellaneous/linear-icon-45/hamburger-menu-5.png`,
  // API End Points
  CONST_SARCASM_BLOG: `${baseUrl}/api/v1/sarcasm/blog`,
  CONST_SARCASM_CONTACT_US: `${baseUrl}/api/v1/sarcasm/contact-us`,
  CONST_SARCASM_BLOG_CATEGORY: `${baseUrl}/api/v1/sarcasm/blog-category`,
  CONST_SARCASM_BLOG_BY_CATEGORY: `${baseUrl}/api/v1/sarcasm/blog-by-category`,
  CONST_SARCASM_SERVICE: `${baseUrl}/api/v1/sarcasm/service`,
  CONST_SARCASM_BLOG_RECENT: `${baseUrl}/api/v1/sarcasm/recent-blogs-for-each-category`,
});
